var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loader-gift-root" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "loader-img",
        style:
          "width: " + _vm.size + "px; height: " + _vm.size + "px; " + _vm.styles
      },
      [
        _c("img", {
          attrs: { src: "https://gift-s365.foxconn.com/imgs/loading.gif" }
        }),
        _c("p", [_vm._v("加載中")])
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.loading,
            expression: "!loading"
          }
        ],
        class: { "data-loading": _vm.text }
      },
      [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }